<!--
* @description:
* @fileName shopManage.vue
* @author hvv
* @date 2022/01/13 15:21:21
!-->
<template>
  <div>
    <vab-query-form style="padding-top: 20px">
      <vab-query-form-left-panel :span="12">
        <el-button type="info" @click="exportReport">导出表格</el-button>
        <el-button type="primary" @click="addRegisterCode">添加注册码</el-button>
        <el-button type="primary" @click="goSmsInvite">短信邀请</el-button>
        <el-button type="success" @click="batchInvite">批量邀请</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="注册码">
            <el-input v-model="queryForm.invitationCode" placeholder="请输入注册码" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="queryForm.status" class="m-2" placeholder="请选择状态">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="注册码" prop="invitationCode" show-overflow-tooltip />
      <el-table-column label="生成时间" prop="createTime" show-overflow-tooltip />
      <el-table-column label="使用者姓名" prop="name">
        <template #default="{ row }">
          <span v-if="row.name == null">/</span>
          <span v-else>
            {{ row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone">
        <template #default="{ row }">
          <span v-if="row.phone == null">/</span>
          <span v-else>
            {{ row.phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="使用时间" prop="useTime">
        <template #default="{ row }">
          <span v-if="row.name == null || row.phone == null">/</span>
          <span v-else>
            {{ row.useTime }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template #default="{ row }">
          <el-tag v-if="row.status == 'TO_BE_USE'" type="success">待使用</el-tag>
          <el-tag v-if="row.status == 'INVALIDATE'" type="danger">作废</el-tag>
          <el-tag v-if="row.status == 'USED'" type="warning">已使用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" show-overflow-tooltip width="185">
        <template #default="{ row }">
          <el-button type="primary" @click="handleSms(row)">短信投放</el-button>
          <el-button type="danger" @click="handleDelete(row)">作废</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <add ref="addRef" @fetch-data="fetchData" />
    <invite ref="inviteRef" @fetch-data="fetchData" />
    <batch-invite ref="batchInviteRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getRegisterCodeList, exportRegisterCodeList, zuofeiRegisterCode } from '@/api/hostApply'
  export default defineComponent({
    name: 'TicketList',
    components: {
      Add: defineAsyncComponent(() => import('./components/addRegisterCode.vue')),
      Invite: defineAsyncComponent(() => import('./components/inviteSms.vue')),
      BatchInvite: defineAsyncComponent(() => import('./components/batchInviteSms.vue')),
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        queryForm: {
          invitationCode: '',
          pageNo: 1,
          pageSize: 20,
          status: 'ALL',
        },
        total: 0,
        shopList: [],
        listLoading: false,
        list: [],
        layout: 'prev, pager, next',
        addRef: null,
        inviteRef: null,
        batchInviteRef: null,
        typeOptions: [
          {
            label: '全部',
            value: 'ALL',
          },
          {
            label: '已使用',
            value: 'USED',
          },
          {
            label: '待使用',
            value: 'TO_BE_USE',
          },
          {
            label: '作废',
            value: 'INVALIDATE',
          },
        ],
      })

      const handleSms = (row) => {
        state.inviteRef.showEdit(row)
      }
      const batchInvite = (row) => {
        state.batchInviteRef.showEdit(row)
      }

      const handleDelete = (row) => {
        if (row.invitationCode) {
          proxy.$baseConfirm('你确定要作废当前邀请码吗？', null, async () => {
            await zuofeiRegisterCode({ invitationCode: row.invitationCode })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getRegisterCodeList(state.queryForm)
        console.log(data, '1123123')
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNo = val
        queryData()
      }

      const addRegisterCode = () => {
        console.log('add')
        state.addRef.showEdit()
      }

      const goSmsInvite = () => {
        proxy.$router.push('/hostApply/smsInvite')
      }

      const exportReport = async () => {
        const { data } = await exportRegisterCodeList()
        window.open(data.url)
      }

      onMounted(() => {
        queryData()
      })
      return {
        ...toRefs(state),
        handleSms,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        addRegisterCode,
        goSmsInvite,
        exportReport,
        batchInvite,
        Delete,
        Search,
        Plus,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
